'use client';
import getComponents from '@functions/component-functions';
import { breakdownChildResponse } from '@functions/amplience-functions';
import ProfileBanner from './_ProfileBanner';
import DeliveryIdContext from '../../context/delivery-id-context';

//TODO: seo rendered through a content row item- switch out

const Author = (props) => {
  const { contentRows, _meta } = props;
  const components =
    contentRows && contentRows.components ? breakdownChildResponse(contentRows.components) : null;

  return (
    <>
      <div className="rotating-background">
        <ProfileBanner {...props} />
      </div>
      <DeliveryIdContext.Provider value={_meta?.deliveryId}>
        {components && components.map((cmpt) => getComponents(cmpt))}
      </DeliveryIdContext.Provider>
    </>
  );
};

export default Author;
